import cards from "../cards";
export default class Cards {
  constructor() {
    this.cards = cards;
    this.container = document.querySelector(".container");
    this.filters = document.querySelectorAll(".filter");
    this.createCards();
    this.setFilters();
    this.DOMCards = document.querySelectorAll(".card");
    this.allFilter();

    // this.createButtons();
  }
  getColor() {
    return `hsl(${360 * Math.random()},30%,90%)`;
  }

  createCards() {
    this.cards.forEach((card) => {
      //parent
      const parent = document.createElement("div");
      parent.dataset.type = card.type;
      parent.classList.add("card");

      //author
      const author = document.createElement("p");
      author.classList.add("author");
      author.innerHTML = card.author;

      //content
      const content = document.createElement("p");
      content.classList.add("content");
      content.innerHTML = card.content;

      //type
      const type = document.createElement("p");
      type.classList.add("type");
      type.innerHTML = card.type;

      //color
      switch (card.type) {
        case "Bedürfnis":
          type.style.color = "hsl(5,100%,50%)";
          break;
        case "Kommentar":
          type.style.color = "hsl(40,100%,50%)";
          break;
        case "Angebot":
          type.style.color = "hsl(200,100%,50%)";
          break;
      }

      parent.appendChild(author);
      parent.appendChild(content);
      parent.appendChild(type);

      this.container.appendChild(parent);
    });
  }

  setFilters() {
    const convertedFilters = Array.from(this.filters);
    convertedFilters.shift();
    convertedFilters.forEach((filter) => {
      filter.addEventListener("click", (e) => {
        e.preventDefault();
        this.setActiveFilter(e);
        this.filterCards(e);
      });
    });
  }

  setActiveFilter(e) {
    this.filters.forEach((filter) => {
      filter.classList.remove("active");
    });

    e.target.classList.add("active");
  }

  filterCards(e) {
    this.setActiveFilter(e);
    // console.log(this.DOMCards);
    this.DOMCards.forEach((card) => {
      card.classList.add("visible");
      card.classList.remove("hidden");
      const cardType = card.dataset.type;
      const filterType = e.target.dataset.filter;

      if (cardType !== filterType) {
        card.classList.remove("visible");
        card.classList.add("hidden");
      }
    });
  }

  allFilter() {
    this.filters[0].addEventListener("click", (e) => {
      this.setActiveFilter(e);
      this.DOMCards.forEach((card) => {
        card.classList.add("visible");
        card.classList.remove("hidden");
      });
    });
  }
}
